// config-keys-not-read-in-v1.ts
//
// D7 (R-18): single source of truth for §18 config keys the v1 codebase
// declares in the schema but has ZERO production readers for (measured
// 2026-09-26, `948926c`) — see plan phase-06 Key Insights for the grep that
// produced this list. Loader/CLI callers warn (never reject — the schema
// stays `.strict()` so old config files keep parsing) whenever a USER'S
// file explicitly sets one of these; seeded/default values never warn.
//
// Dot-paths (`a.b`) so nested keys (mattermost.*) are expressible without a
// second list.
export const CONFIG_KEYS_NOT_READ_IN_V1: readonly string[] = [
  "poll_interval_sec",
  "poll_interval_gate_sec",
  "local_control_tick_ms",
  "heartbeat_sec",
  "max_fix_cycles_without_progress",
  "rate_limit_signatures",
  "no_progress_reminder_hours",
  "outbox_max_pending",
  "timezone",
  "max_internal_subagents",
  "mattermost.persona_mode",
  "mattermost.channel_name",
];

function readPath(obj: unknown, path: string): unknown {
  return path.split(".").reduce<unknown>((acc, segment) => {
    if (acc === null || typeof acc !== "object") return undefined;
    return (acc as Record<string, unknown>)[segment];
  }, obj);
}

/**
 * Pure: which of CONFIG_KEYS_NOT_READ_IN_V1 the raw (pre-validation, as
 * parsed from the user's file) JSON explicitly declares — never the loader's
 * own seed/defaults, since those are not something the USER wrote.
 */
export function findUnusedKeysDeclaredInFile(rawJson: unknown): string[] {
  if (rawJson === null || typeof rawJson !== "object") return [];
  return CONFIG_KEYS_NOT_READ_IN_V1.filter((key) => readPath(rawJson, key) !== undefined).map(
    (key) => `config: key "${key}" khai nhưng v1 chưa dùng — bỏ qua`,
  );
}

/**
 * Used by `autopilot init` (Req 3): reads the global config file directly
 * (init has no controlRoot snapshot to reuse) and returns the same warning
 * strings the loader would. ENOENT or malformed JSON => `[]` (init's own
 * `loadEffectiveConfig` call already surfaces that as a hard error before
 * this ever runs — never a second, duplicate diagnostic here).
 */
export async function readUnusedConfigKeyWarnings(globalConfigPath: string): Promise<string[]> {
  let text: string;
  try {
    const { readFile } = await import("node:fs/promises");
    text = await readFile(globalConfigPath, "utf8");
  } catch {
    return [];
  }
  let rawJson: unknown;
  try {
    rawJson = JSON.parse(text);
  } catch {
    return [];
  }
  return findUnusedKeysDeclaredInFile(rawJson);
}
